export const AuthConstant = {
  VALIDATE_TOKEN: 'VALIDATE_TOKEN',
  REGISTER_USER: 'REGISTER_USER',
  CHANGE_PASSWORD_SAGA: "CHANGE_PASSWORD_SAGA",
  UPDATE_PASSWORD: "UPDATE_PASSWORD",
  AUTH: "AUTH",
  LOGIN: 'LOGIN',
  REGISTER: 'REGISTER',
  SET_MESSAGE: "SET_MESSAGE",
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  UPDATE_USER: "UPDATE_USER",
  SET_USER: "SET_USER",
  UPDATE_REGISTER_STATUS: "UPDATE_REGISTER_STATUS",
  ALL_STATUS_RESET: "ALL_STATUS_RESET",
  ALL_RESET_STATUS: "ALL_RESET_STATUS",
  USER_INFO: "USER_INFO",
  SET_USER_INFO: "SET_USER_INFO",
  SAVE_FEEDBACK: "SAVE_FEEDBACK",
  VALIDATE_PASSWORD_TOKEN: "VALIDATE_PASSWORD_TOKEN"
}